import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { LOADER_SIZE, LOADER_LABEL_VARIANTS, LOADER_VARIANTS } from '../constants';
import { ProgressTrack, LoaderLabel } from '../elements';

const StyledProgressBarWrapper = styled.div`
  cursor: progress;
  display: flex;
  flex-direction: ${({ isInline }) => (isInline ? 'row' : 'column')};
`;

const IndeterminateProgressBar = ({
  className,
  dataTestId,
  hideLabel = false,
  isInline = false,
  label = 'Loading...',
  loaderSize = LOADER_SIZE.LARGE,
  trackWidth,
  ...other
}) => {
  return (
    <StyledProgressBarWrapper
      data-testid={dataTestId ? `${dataTestId}-progress-bar-wrapper` : undefined}
      isInline={isInline}
      role="status"
      {...other}
    >
      {label && (
        <LoaderLabel
          labelMaxWidth={trackWidth}
          labelVariant={LOADER_LABEL_VARIANTS.INDETERMINATE}
          {...{ dataTestId, hideLabel, isInline, label, loaderSize }}
        >
          {label}
        </LoaderLabel>
      )}
      <ProgressTrack variant={LOADER_VARIANTS.INDETERMINATE} {...{ className, dataTestId, loaderSize, trackWidth }} />
    </StyledProgressBarWrapper>
  );
};

IndeterminateProgressBar.propTypes = {
  /** Adds additional class name to progress bar track */
  className: PropTypes.string,
  /** Id value used for testing */
  dataTestId: PropTypes.string,
  /** If true, label will be inline with progress loader and will have a max-width of 194px. */
  isInline: PropTypes.bool,
  /** Visually hides loader text */
  hideLabel: PropTypes.bool,
  /** Adds message to left of loader */
  label: PropTypes.node,
  /** Sets the size of the loader to small or large */
  loaderSize: PropTypes.oneOf(Object.values(LOADER_SIZE)),
  /** Sets the className of the spinner for CSS targeting */

  trackWidth: PropTypes.string.isRequired,
};

export { IndeterminateProgressBar };
